import React from 'react';
import { Card, Tag, Row, Col, Space, Typography, Divider } from 'antd';
import { 
  TagsOutlined, 
  // BoxOutlined, 
  AlertOutlined, 
  DollarOutlined,
  ShoppingCartOutlined,
  ContainerOutlined 
} from '@ant-design/icons';
import './MaterialCard.css'; // New styles

const { Title, Text } = Typography;

const MaterialCard = ({ material }) => {
  if (!material) return null;

  const renderPrice = (price) => (
    price !== undefined && price !== null ? (
      <Text className="price-text">{parseFloat(price).toFixed(2)}</Text>
    ) : (
      <Text className="price-placeholder">—.—</Text>
    )
  );

  return (
    <Card 
      className="modern-material-card"
      hoverable
      bodyStyle={{ padding: '24px' }}
    >
      {/* Modern Gradient Header */}
      <div className="card-header">
        <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
          <Space>
            <ContainerOutlined className="header-icon" />
            <Title level={3} className="material-title" style={{ margin: 0 }}>
              {material.name}
            </Title>
          </Space>
          <Tag className="stock-badge">
            {parseFloat(material.stockAmount || 0).toFixed(2)} {material.unit || ''}
          </Tag>
        </Space>
      </div>

      <Divider style={{ margin: '24px 0' }} />

      {/* Modern Metric Grid */}
      <Row gutter={[16, 16]} className="metrics-grid">
        <Col xs={24} sm={12}>
          <div className="metric-card">
            <TagsOutlined className="metric-icon category" />
            <div>
              <Text className="metric-label">الفئة</Text>
              <Text className="metric-value">{material.categoryName || 'غير محدد'}</Text>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="metric-card">
            <AlertOutlined className="metric-icon negative-balance" />
            <div>
              <Text className="metric-label">السماح برصيد سالب</Text>
              <Text className="metric-value">
                <Tag color={material.allowNegativeBalance ? "green" : "red"}>
                  {material.allowNegativeBalance ? 'نعم' : 'لا'}
                </Tag>
              </Text>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={8}>
          <div className="metric-card">
            <div>
              <Text className="metric-label">سعر الوحدة</Text>
              {renderPrice(material.unitPrice)}
            </div>
          </div>
        </Col>

        <Col xs={24} sm={8}>
          <div className="metric-card">
            <div>
              <Text className="metric-label">سعر البيع</Text>
              {renderPrice(material.retailPrice)}
            </div>
          </div>
        </Col>

        <Col xs={24} sm={8}>
          <div className="metric-card price">
            {/* <BoxOutlined className="metric-icon" /> */}
            <div>
              <Text className="metric-label">سعر الجملة</Text>
              {renderPrice(material.wholesalePrice)}
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default MaterialCard;

